import { render, staticRenderFns } from "./AppFrame.vue?vue&type=template&id=2e4f212a&scoped=true&"
import script from "./AppFrame.vue?vue&type=script&lang=js&"
export * from "./AppFrame.vue?vue&type=script&lang=js&"
import style0 from "./AppFrame.vue?vue&type=style&index=0&id=2e4f212a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4f212a",
  null
  
)

export default component.exports